import { useEffect, useState } from "react";
import { MessageCircle, ArrowUp, Phone } from "lucide-react";

export default function FloatingActions() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-5 bottom-5 z-50 flex flex-col gap-3">
      <a
        href="https://wa.me/917880084126"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        className="w-14 h-14 rounded-full bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/40 hover:scale-110 transition-transform pulse-glow"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
      <a
        href="tel:+917880084126"
        data-testid="float-call"
        className="w-14 h-14 rounded-full bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/40 hover:scale-110 transition-transform"
        aria-label="Call us"
      >
        <Phone className="w-5 h-5 text-white" />
      </a>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="float-top"
          className="w-12 h-12 rounded-full glass-strong flex items-center justify-center hover:bg-white/10 transition-colors"
          aria-label="Back to top"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
